import { NgModule, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, FilterMatchMode, MessageService, Translation } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
//import { CarouselModule } from 'primeng/carousel';
import { CascadeSelect, CascadeSelectModule } from 'primeng/cascadeselect';
//import {ChartModule} from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
//import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { ColorPickerModule } from 'primeng/colorpicker';
//import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DialogService } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
//import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
//import { LightboxModule } from 'primeng/lightbox';
import { ListboxModule } from 'primeng/listbox';
//import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
//import { OrganizationChartModule } from 'primeng/organizationchart';
//import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
//import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
//import { PickListModule } from 'primeng/picklist';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
//import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
//import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SpeedDialModule } from 'primeng/speeddial';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { StepperModule } from 'primeng/stepper';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
//import { TabMenuModule } from 'primeng/tabmenu';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
//import { TerminalModule } from 'primeng/terminal';
import { TextareaModule } from 'primeng/textarea';
//import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
//import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { TippyDirective } from '@ngneat/helipopper';
import { NgxColorsModule } from 'ngx-colors';
import { AutoFocus, AutoFocusModule } from 'primeng/autofocus';
import { PrimeNG } from 'primeng/config';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { MainAppService } from '../app-template/services/main-app.service';
import { DynamicTooltipDirective } from './directives/dynamic-tooltip.directive';

@NgModule({
    declarations: [
        DynamicTooltipDirective
    ],
    imports: [
        AccordionModule,
        AvatarModule,
        AvatarGroupModule,
        AutoCompleteModule,
        AutoFocusModule,
        BadgeModule,
        BlockUIModule,
        BreadcrumbModule,
        ButtonModule,
        CardModule,
//        CarouselModule,
        CascadeSelectModule,
//        ChartModule,
        CheckboxModule,
        ChipModule,
//        CodeHighlighterModule,
//        ConfirmDialogModule,
        ConfirmPopupModule,
        ColorPickerModule,
        ContextMenuModule,
        DataViewModule,
        DatePickerModule,
        DividerModule,
        DialogModule,
        FieldsetModule,
        FileUploadModule,
//        GalleriaModule,
        InplaceModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputMaskModule,
        InputNumberModule,
        InputTextModule,
//        LightboxModule,
        ListboxModule,
//        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MultiSelectModule,
        OrderListModule,
//        OrganizationChartModule,
//        PaginatorModule,
        PanelModule,
//        PanelMenuModule,
        PasswordModule,
//        PickListModule,
        PopoverModule,
        ProgressBarModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        RatingModule,
//        ScrollPanelModule,
        SelectModule,
        SelectButtonModule,
//        SlideMenuModule,
        SliderModule,
        SpeedDialModule,
        SplitButtonModule,
        SplitterModule,
        StepperModule,
        StepsModule,
        TableModule,
//        TabMenuModule,
        TabsModule,
        TagModule,
//        TerminalModule,
        TextareaModule,
//        TieredMenuModule,
        TimelineModule,
        ToastModule,
        ToggleButtonModule,
        ToggleSwitchModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
//        VirtualScrollerModule
        FormsModule,
        NgxColorsModule,
        TippyDirective
    ],
    exports: [
        AccordionModule,
        AutoCompleteModule,
        AutoFocusModule,
        AvatarModule,
        AvatarGroupModule,
        BadgeModule,
        BlockUIModule,
        BreadcrumbModule,
        ButtonModule,
        CardModule,
//        CarouselModule,
        CascadeSelectModule,
//        ChartModule,
        CheckboxModule,
        ChipModule,
//        CodeHighlighterModule,
//        ConfirmDialogModule,
        ConfirmPopupModule,
        ColorPickerModule,
        ContextMenuModule,
        DataViewModule,
        DatePickerModule,
        DialogModule,
        DividerModule,
        DynamicTooltipDirective,
        FieldsetModule,
        FileUploadModule,
//        GalleriaModule,
        InplaceModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputMaskModule,
        InputNumberModule,
        InputTextModule,
//        LightboxModule,
        ListboxModule,
//        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MultiSelectModule,
        OrderListModule,
//        OrganizationChartModule,
//        PaginatorModule,
        PanelModule,
//        PanelMenuModule,
        PasswordModule,
//        PickListModule,
        PopoverModule,
        ProgressBarModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        RatingModule,
//        ScrollPanelModule,
        SelectModule,
        SelectButtonModule,
//        SlideMenuModule,
        SliderModule,
        SpeedDialModule,
        SplitButtonModule,
        SplitterModule,
        StepsModule,
        StepperModule,
        TableModule,
//        TabMenuModule,
        TabsModule,
        TagModule,
//       TerminalModule,
        TextareaModule,
//        TieredMenuModule,
        TimelineModule,
        ToastModule,
        ToggleButtonModule,
        ToggleSwitchModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
//        VirtualScrollerModule
        FormsModule,
        NgxColorsModule,
        TippyDirective
    ],
    providers: [
        AutoFocus,
        CascadeSelect,
        ConfirmationService,
        DialogService,
        MessageService
    ]
})
export class PrimeModule {

    static instance: PrimeModule;

    config = inject(PrimeNG);
    app = inject(MainAppService);

    constructor() {
        PrimeModule.instance = this;
        
        this.config.filterMatchModeOptions = {
            text: [
                FilterMatchMode.CONTAINS,
                FilterMatchMode.EQUALS,
                FilterMatchMode.NOT_EQUALS,
                FilterMatchMode.STARTS_WITH,
                FilterMatchMode.NOT_CONTAINS,
                FilterMatchMode.ENDS_WITH
            ],
            numeric: [
                FilterMatchMode.EQUALS,
                FilterMatchMode.NOT_EQUALS,
                FilterMatchMode.LESS_THAN,
                FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
                FilterMatchMode.GREATER_THAN,
                FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
            ],
            date: [
                FilterMatchMode.DATE_IS,
                FilterMatchMode.DATE_IS_NOT,
                FilterMatchMode.DATE_BEFORE,
                FilterMatchMode.DATE_AFTER
            ]
        };
    }

    setLanguage(language: string): void {
        if (language != "en") {
            this.config.setTranslation(this.app.getTranslationMap().primeng as Translation);
        }
    }

}
